import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-validation',
  templateUrl: './validation.page.html',
  styleUrls: ['./validation.page.scss'],
})
export class ValidationPage implements OnInit {

  objetpass:any;
private data:any
  constructor(private modalCtrl:ModalController,private _route:Router,private nvparms:NavParams) {
    this.data=this.nvparms.get('value')
   }

  ngOnInit() { 
    //<h2>Paiement effectué avec succès !!</h2>
    
       if (this.data.avance) {
        this.data.msg="Avance effectuée avec succès !!"
       }else{
        this.data.msg="Paiement effectué avec succès !!"
       }
    this.objetpass=this.data //this.nvparms.get('value');
   //console.log(this.nvparms.get('value')); 
  }
  closeModal(){
    this.modalCtrl.dismiss();
  }
  onforward(){
   
    this.modalCtrl.dismiss();
      this._route.navigate(['historique'])

  }
}
